import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { FluxStatusSummaryDto } from 'lib_api/lib/api/gen';

import { useApi } from '../ApiStoreContext';
import { backAlertMessage } from '../utils/backAlertMessage';

export function useAdminFluxStatuses(): UseQueryResult<FluxStatusSummaryDto> {
  const { AdminFonctionnelControllerApi } = useApi();

  const loadStatuses = (): Promise<FluxStatusSummaryDto> =>
    AdminFonctionnelControllerApi.getFluxStatusesUsingGET().catch(
      (error: Response) => {
        void backAlertMessage(error);
        const empty: FluxStatusSummaryDto = { statuses: [] };
        return empty;
      },
    );

  return useQuery({
    queryKey: ['flux-statuses'],
    queryFn: loadStatuses,
  });
}
